import { render, staticRenderFns } from "./MLsportEuropeanCartNew.vue?vue&type=template&id=07bdc436&scoped=true"
import script from "./MLsportEuropeanCartNew.vue?vue&type=script&lang=js"
export * from "./MLsportEuropeanCartNew.vue?vue&type=script&lang=js"
import style0 from "./MLsportEuropeanCartNew.vue?vue&type=style&index=0&id=07bdc436&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bdc436",
  null
  
)

export default component.exports